module.exports = __webpack_public_path__ + "img/tn.6eb3e504.svg";